<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M20.7778 4.35294V22H3.77783V4.35294H6.3165V5.52941H4.91117V20.8235H19.6445V5.52941H18.1938V4.35294H20.7778ZM17.3778 7.88235H7.17783V3.17647H10.6798C10.9178 2.49412 11.5412 2 12.2778 2C13.0145 2 13.6492 2.49412 13.8758 3.17647H17.3778V7.88235ZM16.2445 4.35294H12.8445V3.76471C12.8445 3.43529 12.5952 3.17647 12.2778 3.17647C11.9605 3.17647 11.7112 3.43529 11.7112 3.76471V4.35294H8.31117V6.70588H16.2445V4.35294Z"
      :class="colorClass"
    />
    <path
      d="M16.7678 9.34314L10.9943 18L7.77783 15.1863L8.21734 14.7059L10.8644 17.0294L16.2284 9L16.7778 9.35294L16.7678 9.34314Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
